"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmpty = void 0;
const isEmpty = (val) => val === '' || val === undefined || val === null ? true : false;
exports.isEmpty = isEmpty;
